import { RouteType } from "types/RouteType";
import type { RootStore } from "stores/index";
import PurchaseOrdersStore from "./PurchaseOrders.Store";

/**
 * Purchase Orders Route
 *
 * Main PO management view per spec 02-purchase-order-management.md
 * Includes listing, create/edit, and detail dialogs
 */
const purchaseOrdersRoute: RouteType = {
  name: "Purchase Orders",
  path: "/accounting/purchase-orders",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Purchase Orders",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./PurchaseOrders.Header"),
    },
    body: {
      component: () => import("./PurchaseOrders.Body"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any).purchaseOrdersStore as PurchaseOrdersStore;
    if (store) {
      await store.loadPurchaseOrders();
    }
    return true;
  },
  onParamsChange: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any).purchaseOrdersStore as PurchaseOrdersStore;
    if (store) {
      await store.loadPurchaseOrders();
    }
  },
  dialogs: [
    {
      name: "createPO",
      title: "Create Purchase Order",
      component: () => import("./dialogs/CreatePODialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        // Handle PO creation
      },
      onSubmitValidation: ({ rootStore }: { rootStore: RootStore }) => {
        const store = (rootStore as any).purchaseOrdersStore as PurchaseOrdersStore;
        const validation = store?.validatePO(store.formData);
        return !validation?.isValid;
      },
      cancelButton: true,
      height: 700,
    },
    {
      name: "poDetails",
      title: "Purchase Order Details",
      component: () => import("./dialogs/PODetailsDialog.Body"),
      cancelButton: true,
      height: 600,
    },
    {
      name: "partialReceive",
      title: "Partial Receiving",
      component: () => import("./dialogs/PartialReceiveDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        // Handle partial receive
      },
      cancelButton: true,
      height: 500,
    },
  ],
};

export default purchaseOrdersRoute;
